import { getVisitorLogin } from '../api';
const visitorLogin = {
  namespaced: true,
  state: {
    loginData: null
  },
  mutations: {
    GET_VISITOR_LOGIN(state, resp) {
      state.resp = resp;
    }
  },
  actions: {
    async getVisitorLogin({ commit }, obj) {
      let resp = await getVisitorLogin(obj);
      commit('GET_VISITOR_LOGIN', resp);
    }
  }
}

export default visitorLogin



// WEBPACK FOOTER //
// ./src/page/visitor/visitorLogin/store/visitorLogin.store.js